import { Box } from "@mui/material";
import Logo from "../../assets/images/logo.svg";
import { ReactComponent as DiscordIcon } from "../../assets/images/closed/discord.svg";

import "./closed.scss";
import { DOC_LINK } from "src/constants/misc";

export default function Closed() {
  const desc1 =
    "We regret to announce that our protocol is now officially closed. We sincerely appreciate your support.";
  const desc2 =
    "For any inquiries, assistance, or if you'd like to stay connected, please don't hesitate to join our Discord community.";

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      justifyContent="center"
      alignItems={"center"}
      className="bg"
    >
      <img src={Logo} alt="logo" className="logo" />
      <div className="desc">
        {desc1}
        <br />
        <br />
        {desc2}
      </div>
      <a href={DOC_LINK.discord} target="_blank" className="" rel="noreferrer">
        <div className="discordBg">
          <DiscordIcon />
          <div className="">DISCORD</div>
        </div>
      </a>
    </Box>
  );
}
